import { PRIMARY_OUTLET, Router } from '@angular/router';
import { Component, OnInit, ViewChild, Input, ElementRef, HostListener, Inject, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { LoginService } from 'src/app/Service/login.service';
import { NotificationService } from 'src/app/Service/notification.service';

import { HelpdeskSupportDetailsComponent } from './helpdesk-support-details/helpdesk-support-details.component';
import { MatDialog } from '@angular/material/dialog';
import html2canvas from 'html2canvas';
import { HeaderNotesComponent } from './header-notes/header-notes.component';
import { HeaderCalculatorComponent } from './header-calculator/header-calculator.component';
import { environment } from 'src/environments/environment';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { PushNotificationService } from 'src/app/Service/pushnotification/pushnotification.service';
import { IMarkNotificationAsReadModel, INotifcationDetails } from 'src/app/ViewModel/PushNotificationModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { MenuViewModel } from 'src/app/ViewModel/MenuModel';
import { IElasticDocModel, IElasticProjRedirectModel } from 'src/app/ViewModel/ElasticSearch.Model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { from } from 'rxjs/internal/observable/from';

interface Item {
  text: string;
  value: number;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @ViewChild('searchInput') searchInput!: ElementRef;
  renderMenu = false;
  @Input() header: any;
  fileds = { name: 'menuDesc', url: 'menuUrl', icon: 'widgetImage', subMenu: 'childList' };
  menu :any= [];
  hoverClass = '';
  clickEventClass = '';
  @Input()
  public handleStyle = {};
  adminFlag = false;
  edms2Pages: string[] = ['Peer Review', 'DIARCL', 'DDP', 'RiskReport', 'ProjectRiskReport', 'Risk', 'CSRAnalysis', 'CSRRequest', 'CSR', 'Innovation And Learning'];
  eip4Uri: string = environment.eip4uriHost;
  returnUrl: string = environment.returnUrl;
  opendropdown = false;
  currentDateTime: any = '';
  isBackButtonEnabled = false;
  currentUserId: number = 0;
  currentUserName: string = '';
  currentUserEmailId: string = '';
  currentUserDesignation: string = '';
  currentUserNameInitial: string = '';
  currentUserContactNumber: string = '';
  eipUserId!: number;
  @Input() showFloatingIcons: boolean = true;
  @Input() HelpDeskParameters: any;
  @ViewChild('floatingiconTrigger') public floatingiconTrigger:any;
  showchatpopup = false;
  openhelpdesk = false;
  HelpdeskDocs: any;
  screen: any;
  img: any;
  breadcrumbs:any;
  isHDenable: any = true;
  helpdeskImgList: any = [];
  helpdeskImgListbytes: any = [];
  pushNotifications: any[] = [];
  incidentManagementUrl: string;
  isOpenDialogCalculator = false;
  placeholder: string = "Type to Search";
  showNotification = false;
  notificationsCount!: number;
  public listItems: Array<Item> = [
    { text: " Please Select ", value: 0 },
    { text: "Communication", value: 1 },
    { text: "Schedule Document", value: 2 },
    { text: "Repository Document", value: 3 },
  ];
  public selectedItem: Item = this.listItems[0];
  esFilterOutput: IElasticDocModel[] = [];
  searchDefaultValue = '';
  displayText = '';
  @Output() esSelectedProjectChanged = new EventEmitter<any>();
  constructor(public router: Router, private activatedRoute: ActivatedRoute,
    private commonService: CommonService, private encryptDecryptService: EncryptDecryptService,
    public dialog: MatDialog,
    private loginService: LoginService,
    private _notificationService: NotificationService,
    private _pushNotificationService: PushNotificationService,
    private notificationService: NotificationService,
    private route: Router, @Inject('environment') env: any) {

    this.routeEvent(this.route);

    setInterval(() => {
      this.currentDateTime = new Date();
    }, 1);
    const redirectUrl = `${environment.eip4uriHost}helpdesk/CommonGetSession.aspx?strPage=HDSCallReviewList.aspx&SessionID=`;
    this.incidentManagementUrl = `${environment.eip4uriHost}eiproot/sessiontransfer?URL=${encodeURIComponent(redirectUrl)}`;
  }

  ngOnInit() {
    if (this.commonService.hasJWT()) {
      let profileCard = this.commonService.getCurrentUserProfileCard();
      this.currentUserId = profileCard['memberId'];
      this.currentUserName = profileCard['memberName'];
      this.currentUserNameInitial = this.currentUserName.charAt(0);
      this.currentUserEmailId = profileCard['eMailId'];
      this.currentUserDesignation = profileCard['designation'];
      this.currentUserContactNumber = profileCard['mobileNo'];
      this.eipUserId = profileCard['eipUserId'];
      this._pushNotificationService.getPushNotificationList().subscribe((res: any[]) => {
        this.pushNotifications = res;
        this.notificationsCount = this.pushNotifications.length;
      });
      this.commonService.selectedProjectId.subscribe((data:any) => {
        if (data != null || data != undefined) {
          this.getMenus(data, this.commonService.getLoggedInUserId(), this.commonService.getLoggedInUserGroupId());
        }
      });
    }

    let snapshot = this.router.routerState.snapshot;
    this.breadcrumbs = [];
    let url = snapshot.url;
    let routeData:any = this.activatedRoute.snapshot.data;

    let label = routeData['breadcrumb'];
    let params = snapshot.root.params;

    this.breadcrumbs.push({
      url: url,
      label: label,
      params: params
    });
    let Url: string = this.breadcrumbs[0].url;
    let splitUrl = Url.split('/');
    splitUrl = splitUrl.filter(data => data);
    this.breadcrumbs = this.breadcrumbs.map((data:any) => {
      return {
        parentUrl: this.capitalizeFirstLetter(splitUrl[0]),
        childurl: this.capitalizeFirstLetter(splitUrl[1]),
        url: data.url,
        label: data.label,
        params: data.params
      }
    })

    this.screen = document.getElementsByTagName('body')[0];
  }
  // program to convert first letter of a string to uppercase
  capitalizeFirstLetter(str: string) {
    // converting first letter to uppercase
    const capitalized = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalized;
  }

  Opendropdown() {
    this.opendropdown = !this.opendropdown;
  }

  navigateToHome() {
    this.router.navigate(['/dashboard/home']);
  }

  onSignOut() {
    this.loginService.Logout(this.commonService.getLoggedInUserStatus());
  }

  chatpopup() {
    this.showchatpopup = !this.showchatpopup;
    const ele = this.floatingiconTrigger.nativeElement;
    if (this.showchatpopup) {
      ele.classList.add('activepopup');
    } else {
      ele.classList.remove('activepopup');
    }
  }

  chatHandler() {
    window.open('https://aka.ms/mstfw', '_blank');
  }

  // HELPDESK SUPPORT FMS
  openHelpdesk() {
    if (this.HelpDeskParameters) {
      const body = this.HelpDeskParameters;
      // const helpdeskSubscriber = this.eipHeaderService.GetHelpdeskDocuments(body).
      //   subscribe(result => {
      //     this.HelpdeskDocs = result;
      //     this.HelpdeskDocs = this.eipHeaderHelper.setFileExtension(this.HelpdeskDocs);
      //     if (helpdeskSubscriber) {
      //       helpdeskSubscriber.unsubscribe();
      //     }
      //   });
    }
  }

  public downloadFile(file: any) {
  }

  capture() {
    const options = {
      logging: false
    };
    this.floatingiconTrigger.nativeElement.style.display = 'none';
    this.commonService.clearImgList = new BehaviorSubject<boolean>(false); 
    return from(
      html2canvas(this.screen, options).then(
        (canv:any) => {
          const img = canv.toDataURL('image/png');

          this.img = img;
          this.floatingiconTrigger.nativeElement.style.display = 'block';

          var BASE64_MARKER = ';base64,';
          var base64Index = img.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
          var base64 = img.substring(base64Index);
          var raw = window.atob(base64);
          var rawLength = raw.length;
          var array = new Uint8Array(new ArrayBuffer(rawLength));

          for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
          }
          this.helpdeskImgList.push({ 'Base64': this.img, 'bytes': array });
          this._notificationService.showToast('Screenshot Taken', 'Information');
          return img;
        }, (err: string ) => {
          this._notificationService.showToast(err, 'Error');
          throw new Error(err);
        }
      ).catch((res: string ) => {
        throw new Error(res);
      })
    );

  }

  summaryOpener() {
    const dialogRef = this.dialog.open(HelpdeskSupportDetailsComponent, {
      data: { imgList: this.helpdeskImgList, userId: this.currentUserId },
      width: '95%',
      height: 'auto',
      panelClass: 'mat-dialog-primary',
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      const sub = this.commonService.clearImgList.subscribe((value:any) => {
        if (value) { this.helpdeskImgList = []; }
        sub.unsubscribe();
      });
    });
  }

  eipnotesHandler() {
    this.isOpenDialogCalculator = true;
    this.openEIPNotesDialog();
  }
  openEIPNotesDialog(): void {
    const eipNotesparam = {
      userID: this.currentUserId
    };
    if (this.isOpenDialogCalculator) {
      const dialogRef = this.dialog.open(HeaderNotesComponent, {
        data: { eipNotesparam }
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        this.isOpenDialogCalculator = false;
      });
    }
  }

  calculatorHandler() {
    this.isOpenDialogCalculator = true;
    this.openEIPCaluclatorDialog();
  }

  openEIPCaluclatorDialog(): void {
    if (this.isOpenDialogCalculator) {
      const dialogRef = this.dialog.open(HeaderCalculatorComponent, {
        data: {}
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        this.isOpenDialogCalculator = false;
      });
    }
  }

  searchTypeChange(data:any) {
    this.selectedItem = data;
    this.esFilterOutput = [];
    this.searchInput.nativeElement.value = '';

    if (data.value == 0)
      this.placeholder = "Type to Search";
    else
      this.placeholder = "Type to Search within " + data.text;
  }

  searchOnChange() {
    this.esFilterOutput = [];
    let searchText: string = this.searchInput.nativeElement.value;
    if (searchText.length <= 2)
      return;

    this.commonService.elasticSearchFilter(searchText).subscribe((data: IElasticDocModel[]) => {
      if (data) {
        this.esFilterOutput = data;
      }
    });
  }

  autoCompleteChange(esdata: IElasticDocModel) {
    this.displayText = esdata.displayText;
    let currentProjId: number = this.commonService.getProjectId();
    let data = {
      searchDocNo: esdata.recordNumber,
      searchRevNo: esdata.revisionNo
    }
    this.commonService.setSessionStorageItem('searchedObject', this.encryptDecryptService.encrypt(JSON.stringify(data)));
    let redirectURL: string = '';
    switch (esdata.moduleId) {
      case 1:
        redirectURL = '/documents/document';
        break;
      case 2:
        redirectURL = '/engineeringschedule/schedulelist';
        break;
      case 3:
        redirectURL = '/communication/communication';
        break;
    }
    //Reset the search result
    this.esFilterOutput = [];
    this.displayText = '';
    //If search result is from another project, need to switch the project
    if (currentProjId != esdata.projectId) {
      let elasticProjModel: IElasticProjRedirectModel = { projectId: esdata.projectId, redirectUrl: redirectURL }
      this.esSelectedProjectChanged.emit(elasticProjModel);
    }
    else {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([redirectURL]);
    }
  }

  toggleNotification() {
    this.showNotification = !this.showNotification;
  }

  clearNotifications() {
    if (this.notificationsCount > 0) {
      let reqModel: IMarkNotificationAsReadModel = {
        idList: this.pushNotifications.map(x => {
          let notificationDetails: INotifcationDetails = { notificationId: x.notificationId }
          return notificationDetails;
        })
      };
      this._pushNotificationService.markAsReadNotification(reqModel).subscribe((x: StandardOutputModel) => {
        if (x.successCode == 200) {
          this.notificationsCount = 0;
          this.pushNotifications = [];
          this.showNotification = false;
        }
      }, (err:any) => {

      })
    }
  }

  getMenus(projectId: number, userId: number, groupId: number): void {
    if ((projectId != null || projectId != undefined) && userId) {
      this.commonService.getNavigationMenu(projectId, userId, groupId).subscribe((data: MenuViewModel[]) => {
        this.commonService.setSessionStorageItem("Menu", JSON.stringify(data));
        this.menu = data;
        this.renderMenu = data.length > 0;

        if (this.commonService.hasRequestedObject()) {/*Mail Redirection*/
          var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
          let requestedPage = this.menu.filter((x: { menuUrl: string; }) => x.menuUrl.split('/')[1] == requestedObject['page']);

          if (requestedPage.length <= 0) {
            for (let index = 0; index < this.menu['length']; index++) {
              if (requestedPage.length <= 0 && this.menu[index].childList.length > 0) {
                requestedPage = this.menu[index].childList.filter((y: { menuUrl: string; }) => y.menuUrl.split('/')[1] == requestedObject['page']);
              }
            }
          }

          if (requestedPage.length > 0)
            this.navigatePage(requestedPage[0]);
        }
      });
    }
  }

  routeEvent(router: Router) {
    this.render();
  }

  navigationEndEvent(e: NavigationEnd) {
    this.render();
  }

  render() {
    //this.renderMenu = true;
    // this.commonService.selectedProjectId.subscribe(data => {
    //   if (data) {
    //     this.getMenus(data, this.commonService.getLoggedInUserId());
    //   }
    // });
  }

  navigatePage(item: MenuViewModel) {
    if (item.isClickable) {
      if (this.edms2Pages.filter(x => x == item.menuDesc).length > 0) {
        let redirectUrl: string = this.eip4Uri + this.returnUrl + encodeURIComponent("?URL=" + this.eip4Uri + "EDMS/CommonGetSession.aspx?strPage=Common/EDMSMailRedirect.aspx");
        //Queryparameters builder
        let queryParams: string = "&Page_Name=" + item.menuDesc;
        queryParams = queryParams + "&Project_Short_Desc=" + this.commonService.getProjectCode();
        let parameters: string = encodeURIComponent(encodeURIComponent(queryParams));
        let sessionId: string = "&SessionID=";
        sessionId = encodeURIComponent(sessionId);
        let encodedUrl: string = redirectUrl + parameters + sessionId;
        window.open(encodedUrl, "_blank");
      }
      else {
        this.route.navigate([item.menuUrl]);
        this.onHoverTrigger(close);
      }
    }
    else {
      this.notificationService.showToast('Access denied, please contact HelpDesk', "Warning");
    }
  }

  mouseCliked: boolean = true;
  @HostListener('document:click', ['$event'])
  onDocClick(evt:any) {
    // this.mouseCliked = !this.mouseCliked;    
    //  if(this.mouseCliked == true){
    //    this.hoverClass ='close';
    //    return;
    //  }   
    // this.hoverClass = '';
  }

  onHoverTrigger(e:any) {
    if (this.hoverClass == 'open') {
      this.hoverClass = '';
    } else {
      this.hoverClass = 'open';
    }
  }

  isLegacyAppUrl(item: MenuViewModel): boolean {
    return this.edms2Pages.filter(x => x == item.menuDesc).length > 0
  }

}
